import React, { useState, useEffect } from "react";
import {
    FaTimes,
    FaSave,
    FaTools,
} from "react-icons/fa";
import { FaClock } from "react-icons/fa6";

export const TicketRescheduleAction = ({ isOpen, onClose, ticket, onSave }) => {
    // State untuk Form
    const [activeTab, setActiveTab] = useState("status"); // status | schedule | work
    const [loading, setLoading] = useState(false);

    // Form Data
    const [formData, setFormData] = useState({
        status: "",
        scheduleDate: "",
        scheduleTime: "",
        scheduleReason: "", // Wajib jika reschedule
        workNote: "", // Catatan teknisi
        workProgress: 0,
    });

    // Reset form saat modal dibuka/tutup
    useEffect(() => {
        if (isOpen && ticket) {
            setFormData({
                status: ticket.status?.name || "",
                scheduleDate: "",
                scheduleTime: "",
                scheduleReason: "",
                workNote: "",
                workProgress: ticket.workDetails?.progress || 0,
            });
        }
    }, [isOpen, ticket]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Validasi Sederhana
        if (activeTab === "schedule" && (!formData.scheduleDate || !formData.scheduleReason)) {
            alert("Harap isi tanggal dan alasan penjadwalan ulang.");
            setLoading(false);
            return;
        }

        if (activeTab === "work" && !formData.workNote) {
            alert("Harap isi catatan pengerjaan.");
            setLoading(false);
            return;
        }

        // Simulasi Proses Simpan (API Call)
        console.log("Submitting Ticket Action:", formData);

        // Panggil fungsi callback dari parent (opsional)
        if (onSave) await onSave(formData);

        // Simulasi delay
        setTimeout(() => {
            setLoading(false);
            onClose();
            // Reset tab ke awal
            setActiveTab("status");
        }, 1000);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
            {/* Backdrop Blur */}
            <div
                className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            />

            {/* Modal Container */}
            <div className="relative w-full max-w-2xl bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">

                {/* --- Header --- */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-700 bg-slate-800/50">
                    <div>
                        <h2 className="text-lg font-bold text-white flex items-center gap-2">
                            <FaTools className="text-cyan-400" />
                            Aksi Tiket: {ticket?.code}
                        </h2>
                        <p className="text-xs text-slate-400 mt-1">
                            Kelola status, jadwal, dan catatan pengerjaan
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-white transition-colors p-2 rounded-full hover:bg-slate-700"
                    >
                        <FaTimes size={18} />
                    </button>
                </div>

                {/* --- Body Content (Scrollable) --- */}
                <div className="p-6 overflow-y-auto custom-scrollbar flex-1">
                    <div className="space-y-4 animate-in fade-in duration-200">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2">Tanggal Baru</label>
                                <input
                                    type="date"
                                    value={formData.scheduleDate}
                                    onChange={(e) => setFormData({ ...formData, scheduleDate: e.target.value })}
                                    className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2">Jam</label>
                                <input
                                    type="time"
                                    value={formData.scheduleTime}
                                    onChange={(e) => setFormData({ ...formData, scheduleTime: e.target.value })}
                                    className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-semibold text-slate-400 mb-2">
                                Alasan Penjadwalan Ulang <span className="text-red-400">*</span>
                            </label>
                            <textarea
                                rows="3"
                                placeholder="Contoh: Pelanggan tidak ada di rumah..."
                                value={formData.scheduleReason}
                                onChange={(e) => setFormData({ ...formData, scheduleReason: e.target.value })}
                                className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-sm rounded-lg px-4 py-3 focus:outline-none focus:border-cyan-500 resize-none"
                            ></textarea>
                        </div>

                        <div className="p-3 bg-blue-500/5 border border-blue-500/10 rounded-lg flex items-start gap-3">
                            <FaClock className="text-blue-400 mt-1" />
                            <p className="text-xs text-blue-200/80">
                                Jadwal baru akan ditambahkan ke riwayat dan notifikasi akan dikirim ke pelanggan.
                            </p>
                        </div>
                    </div>
                </div>

                {/* --- Footer --- */}
                <div className="p-4 border-t border-slate-700 bg-slate-800/50 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={loading}
                        className="px-5 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-slate-700 hover:text-white transition-colors disabled:opacity-50"
                    >
                        Batal
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-cyan-600 hover:bg-cyan-500 shadow-lg shadow-cyan-900/20 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <>
                                <span className="animate-spin h-4 w-4 border-2 border-white/30 border-t-white rounded-full" />
                                Menyimpan...
                            </>
                        ) : (
                            <>
                                <FaSave />
                                Simpan Perubahan
                            </>
                        )}
                    </button>
                </div>

            </div>
        </div>
    );
};